<!-- svelte-ignore a11y-label-has-associated-control -->
<!-- svelte-ignore a11y-missing-attribute -->
<div class="columns">
  <div class="column">
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Category</label>
      </div>
      <div class="field-body">
        <div class="field">
          <div class="control">
            <div class="select">
              <select bind:value={data.category}>
                <option value={undefined}>Select</option>
                {#each categories as category}
                  <option value={category.id}>{category.label}</option>
                {/each}
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Title</label>
      </div>
      <div class="field-body">
        <div class="field">
          <div class="control">
            <input
              class="input"
              type="text"
              placeholder=""
              bind:value={data.name}
            />
          </div>
        </div>
      </div>
    </div>

    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Description</label>
      </div>
      <div class="field-body">
        <div class="field">
          <div class="control">
            <textarea
              class="textarea"
              placeholder=""
              rows="10"
              bind:value={data.description}
            />
          </div>
        </div>
      </div>
    </div>

    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Image(s)</label>
      </div>
      <div class="field-body">
        <div class="field">
          <div class="control">
            {#if data.images}
              {#each data.images as url, index}
                <div
                  style="display:inline-block;position:relative;margin-right:8px;"
                >
                  <button
                    class="delete"
                    style="position:absolute;top:5px;right:5px;"
                    on:click={() => removeImage(index)}
                  />
                  <img src={url} style="height:200px;" />
                  {#if index === 0}
                    <span 
                      class="tag is-info"
                      style="position:absolute;bottom:10px;left:5px;">
                        Cover image
                    </span>
                  {:else}
                    <button
                      class="tag is-info is-light"
                      style="position:absolute;bottom:10px;left:5px;cursor:pointer;border:none;"
                      on:click={() => setAsCoverImage(index)}>
                        Set as cover image
                    </button>
                  {/if}
                </div>
              {/each}
            {/if}
            {#if fileUploads.length > 0}
              <div class="block">
                {#each fileUploads as fileUpload}
                  {#if !fileUpload.complete}
                    <progress
                      class="progress"
                      value={fileUpload.progress}
                      max="100">{fileUpload.progress}</progress
                    >
                  {/if}
                {/each}
              </div>
            {/if}
            <div class="file">
              <label class="file-label">
                {#if isValid}
                  <input
                    class="file-input"
                    type="file"
                    accept="image/*"
                    name="resume"
                    multiple
                    on:change={upload}
                    bind:this={filesElement}
                  />
                  <span class="file-cta">
                    <span class="file-label"> Choose file(s)... </span>
                  </span>
                {/if}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Location</label>
      </div>
      <div class="field-body">
        <div class="field is-grouped">
          <div class="control">
            {#if data.location}
            <input
              class="input"
              type="text"
              placeholder=""
              bind:value={data.location.postcode}
              readonly
              disabled
            />
            {/if}
          </div>
          <div class="control">
            <a class="button" on:click={editPostcode}>Change</a>
          </div>
        </div>
      </div>
    </div>

    {#if $appState.user?.isAdmin}

    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Distance</label>
      </div>
      <div class="field-body">
        <div class="field">
          <div class="control">
            <div class="select">
              <select bind:value={data.options.distance}>
                <option value={undefined}>default</option>
                <option value={1}>1</option>
                <option value={1}>2</option>
                <option value={3}>3</option>
                <option value={4}>4</option>
                <option value={5}>5</option>
                <option value={6}>6</option>
                <option value={7}>7</option>
                <option value={8}>8</option>
                <option value={9}>9</option>
                <option value={10}>10</option>
                <option value={15}>15</option>
                <option value={20}>20</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>

    {/if}

    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Options</label>
      </div>
      <div class="field-body">
        <div class="field">
          <div class="control mt-2">
            <label class="checkbox">
              <input bind:checked={data.options.nationwide} type="checkbox">
              Offer nationwide (you are willing to post)
          </div>
          <div class="control mt-2">
            <label class="checkbox">
              <input bind:checked={data.options.divisible} type="checkbox">
              Willing to split items across multiple charities
          </div>
          {#if !($appState.company && hasActiveSubscription($appState.company))}
          <div class="control mt-2">
            <label class="checkbox">
              <input bind:checked={data.options.large} type="checkbox">
              Requires Premium access <a href="https://www.agoodthing.org.uk/business-pricing" target="_new">Learn more</a>
          </div>
          {/if}
        </div>
      </div>
    </div>

  </div>
  <div class="column is-3">
    <div class="box">
      <p class="block"><b>Help &amp; advice</b></p>
      <p>Some ideas for what to say.</p>
      <hr />
      {#if data.category && categoriesById[data.category]}
        <p class="block has-text-grey-light">
          {categoriesById[data.category].label}
        </p>
        {#if categoriesById[data.category].help}
          <div class="block">
            <ul>
              {#each categoriesById[data.category].help as tip}
                <li>{tip}</li>
              {/each}
            </ul>
          </div>
        {/if}
        <hr />
      {/if}
      <div class="block">
        <p class="block has-text-grey-light">General</p>
        <div class="block">
          <ul>
            <li>Quantity</li>
            <li>Whole lot or can be split</li>
            <li>Collection-only or delivery</li>
            <li>Deadline for requests</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

<script lang="ts">
  export let data :Offer_v2, isValid:boolean;
  import _ from "lodash";
  import { appState } from '../../../lib/appState';
  import { uiState } from '../../../lib/uiState';
  import { hasActiveSubscription } from '../../../lib/subscriptionHelper';
  import { v4 as uuidv4 } from 'uuid';
  import EditLocation from "./EditLocation.svelte";

  // backwards-compat
  if(!data.options) {
    data.options = {
      nationwide: false
    }
  }

  if(!data.location || !data.location.postcode) {
    data.location = {
      postcode: $appState.company!.postcode,
      point: $appState.company!.location
    }
  }

  const categories : any[] = [
    {
      id: "itl",
      label: "IT equipment - laptops",
      help: [
        "Brand",
        "Windows version (or Mac)",
        "Approx age",
        "Accessories (e.g. power supplies, docks)",
      ],
    },
    {
      id: "ito",
      label: "IT equipment - other",
      help: [
        "Brand",
        "Condition / working order",
        "Accesories and consumables required",
      ],
    },
    {
      id: "ff",
      label: "Office furniture and fittings",
      help: ["Material / colour", "Approx dimensions", "Condition"],
    },
    {
      id: "os",
      label: "Office supplies",
    },
    {
      id: "bm",
      label: "Branded merchandise",
    },
    {
      id: "np",
      label: "New products",
      help: ["Links to product pages"],
    },
    {
      id: "o",
      label: "Other",
    },
  ];

  const categoriesById : any = _.keyBy(categories, "id");

  isValid = true;

  function editPostcode() {      
      $uiState.activeModal = { 
        component: EditLocation,
        props: { 
          setLocation: (postcode :string, point :GeoPoint) => { 
            data.location = {
              postcode,
              point
          }
        } 
      } 
    }
  }

  let filesElement : any;

  let fileUploads: any[] = [];

  let firebase = window.firebase;

  async function updateProgress(index:number, progress: number, complete:boolean = false, url?:string) {
    fileUploads[index].complete = complete;
    fileUploads[index].progress = progress;
    fileUploads[index].url = url;

    if (!isValid && _.every(fileUploads, "complete")) {
      isValid = true;
      data.images = data.images || [];
      // preserve upload order
      fileUploads.forEach((upload) => {
        data.images!.push(upload.url);
      });
    }
  }

  function upload() {
    let files = filesElement.files;

    if (files) {
      fileUploads = [];

      isValid = false;

      const now = new Date();
      const imagesRef = firebase.storage().ref().child("images").child(`${now.getUTCFullYear()}-${now.getUTCMonth()}-${now.getUTCDate()}`);

      for (let i = 0; i < files.length; i++) {
        let file = files[i];

        console.log(file);

        let name = `${uuidv4()}.jpg`;
        let ref = imagesRef.child(name);

        let fileUpload = {
          name,
          progress: 0,
          uploadTask: undefined as any
        };

        let uploadTask = ref.put(file);

        uploadTask.on(
          "state_changed",
          function (snapshot) {
            var progress =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            console.log(progress);

            //fileUpload.progress = progress;
            updateProgress(i, progress);
          },
          function () {
            // failed
          },
          function () {
            console.log("complete");
            uploadTask.snapshot.ref
              .getDownloadURL()
              .then(function (downloadURL) {
                console.log("File available at", downloadURL);
                updateProgress(i, 100, true, downloadURL);
              });
          }
        );

        fileUpload.uploadTask = uploadTask;

        fileUploads = [...fileUploads, fileUpload];
      }
    }
  }

  function removeImage(index: number) {
    data.images = [
      ...data.images!.slice(0, index),
      ...data.images!.slice(index + 1),
    ];
  }

  function setAsCoverImage(index: number) {
    data.images = [
      data.images[index],
      ...data.images,
    ];
    removeImage(index + 1 )
  }
</script>
